// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import { NativeEventSource, EventSourcePolyfill } from 'event-source-polyfill';

const EventSource = NativeEventSource || EventSourcePolyfill;

export class Subscriber {

    url: URL = new URL(process.env.REACT_APP_MERCURE_HUB ? process.env.REACT_APP_MERCURE_HUB : 'http://localhost/hub');

    baseTopicUrl = process.env.REACT_APP_TOPIC_URL ? process.env.REACT_APP_TOPIC_URL : 'http://localhost/hub';

    messageHandlers: any = {};

    instance: any;

    constructor() {
        this.handleMessage = this.handleMessage.bind(this);
    }

    subscribe(): void {
        this.instance = new EventSource(this.url);

        this.instance.addEventListener('message', this.handleMessage)
    }

    addTopic(name: string, context: string, onMessage: any): void {
        if (this.messageHandlers[context]) {
            this.messageHandlers[context].push(onMessage);

        } else {
            this.messageHandlers[context] = [onMessage];

        }

        const existingSearchParams = this.url.searchParams.getAll('topic');

        if (existingSearchParams.indexOf(name) === -1) {
            this.url.searchParams.append('topic', this.baseTopicUrl + name);
        }

    }

    handleMessage(e: any): void {
        const response = JSON.parse(e.data);
        

        this.messageHandlers[response['@context']].forEach((callable: any) => {
            callable(response);
        })
    }

    unsubscribe(): void {
        this.url = new URL(process.env.REACT_APP_MERCURE_HUB ? process.env.REACT_APP_MERCURE_HUB : 'http://localhost/hub');
        this.messageHandlers = {};
        if (this.instance) {
            this.instance.close();
        }
    }
}

export default Subscriber;